<template>
    <div class="audit-next-row-label">{{ label }}</div>
</template>

<script>
    export default {
        name: 'AuditLogField',
        props: {
            name: {
                type: [Number, String],
                required: true,
            },
        },
        computed: {
            label() {
                const text = this.name
                    .toString()
                    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
                    .replace(/\bId\b/g, 'ID')
                    .replace(/2\sFA\s/g, '2FA ')
                    .replace(/Use2\sFA([A-Z])/g, 'Use 2FA $1')
                    .replace(/sz2\sFA([A-Z])/g, '2FA $1')
                    .replace(/l2\sFA([A-Z])/g, '2FA $1')
                    .replace(/2\sFA\s/g, '2FA ')
                    .replace(/^((sz|l|b|txt|chk|a|sel)\s)/g, '')
                    .replace(/OIType/g, 'OI Type');
                return text.charAt(0).toUpperCase() + text.slice(1);
            },
        },
    };
</script>
